import { Request } from '../request';
import { IProviderSettingDetailResponse, ISaveProviderSettingInput, IBatchSaveReviewItem } from 'types/klarityReview';

/**
 * 获取 Provider Setting 详情
 * @returns {Promise<IProviderSettingDetailResponse>} Provider Setting 详情
 */
export const getProviderSettingDetail = () =>
    Request.get<IProviderSettingDetailResponse>({
        url: '/schedule-server/klarity/provider/setting/detail',
    });

/**
 * 保存 Provider Setting
 * @param {ISaveProviderSettingInput} data - 保存设置的数据
 * @returns {Promise<any>} 保存结果
 */
export const saveProviderSetting = (data: ISaveProviderSettingInput) => {
    const enableValue = data.enableReview ? 'true' : 'false';
    return Request.post({
        url: `/schedule-server/klarity/provider/setting/review/enable/${enableValue}`,
        params: {},
    });
};

/**
 * 批量保存评论
 * @param {IBatchSaveReviewItem[]} reviews - 评论列表，每个评论包含 reviewContent 和 date
 * @returns {Promise<any>} 保存结果
 */
export const batchSaveReviews = (reviews: IBatchSaveReviewItem[]) =>
    Request.post<IBatchSaveReviewItem[]>({
        url: '/schedule-server/provider/klarity/review/save/batch',
        params: reviews,
    });

/**
 * 获取已上传的评论条数
 * @returns {Promise<number>} 已上传的评论条数
 */
export const getUploadedReviewCount = () =>
    Request.get<number>({
        url: '/schedule-server/provider/klarity/review/import/count',
    });
